<template>
  <div class="clock-out-photo-upload">
    <b-button
      variant="outline-primary"
      size="sm"
      class="mb-2"
      @click="launchFilePicker"
    >
      <b-icon icon="camera" class="mr-1" /> Add photo
    </b-button>

    <b-form-file
      ref="filePicker"
      multiple
      accept="image/jpeg, image/png"
      style="display: none"
      @input="onFilesSelected"
    ></b-form-file>

    <div class="preview-container" v-if="previews.length">
      <div class="preview-item" v-for="(preview, i) in previews" :key="i">
        <b-icon-x-circle-fill
          variant="dark"
          class="remove-icon"
          @click="removePhoto(i)"
        />
        <b-img :src="preview" alt="Clock-out photo" class="h-100" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClockOutPhotoUpload',

  props: {
    // Array of File objects, kept in sync via v-model on the parent
    value: { type: Array, default: () => [] },
  },

  data() {
    return {
      previews: [],
    }
  },

  methods: {
    launchFilePicker() {
      this.$refs.filePicker.$el.querySelector('input').click()
    },

    onFilesSelected(files) {
      if (!files) return
      const list = Array.isArray(files) ? files : [files]
      const images = list.filter(
        (f) => f && f.type && f.type.startsWith('image/'),
      )

      images.forEach((file) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.previews.push(e.target.result)
        }
        reader.readAsDataURL(file)
      })

      this.$emit('input', [...this.value, ...images])
    },

    removePhoto(index) {
      this.previews.splice(index, 1)
      const updated = [...this.value]
      updated.splice(index, 1)
      this.$emit('input', updated)
    },
  },
}
</script>

<style lang="scss" scoped>
// main.scss gives .preview-container a fixed 200px height for the carousel
// uploads; here it would leave a big gap under the thumbnails.
.preview-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  height: auto;
  overflow: visible;
  white-space: normal;
}

.preview-item {
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e5e7eb;

  img,
  ::v-deep img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.remove-icon {
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
  cursor: pointer;
  background: #fff;
  border-radius: 50%;
}
</style>
